import { render, staticRenderFns } from "./moveTaskDetail.vue?vue&type=template&id=33bec630&scoped=true&"
import script from "./moveTaskDetail.js?vue&type=script&lang=js&"
export * from "./moveTaskDetail.js?vue&type=script&lang=js&"
import style0 from "./moveTaskDetail.scss?vue&type=style&index=0&id=33bec630&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bec630",
  null
  
)

export default component.exports